import React from 'react';
import { Modal, Table, Form, Empty, Input, Tag } from 'antd';
import { APROBADO, REGISTRADO, ANULADO, RECHAZADO } from '../../../common/types/ordenProduccionEstadoType';

export default class ImportarOrdenProduccionModal extends React.Component {
    render() {
        const renderColor = (row) => {
            if (row.idOrdenProduccionEstado === REGISTRADO)
                return 'blue';
            if (row.idOrdenProduccionEstado === APROBADO)
                return 'green';
            if (row.idOrdenProduccionEstado === RECHAZADO)
                return 'orange';
            if (row.idOrdenProduccionEstado === ANULADO)
                return 'red';
        };


        //handleSearch = (value) => {
        //    const dataSource = this.props.dataSource.filter(item => {
        //        return global.formatSearch(`${item.serie} - ${item.documento}`).match(global.formatSearch(value));
        //    });
        //    this.props.form.setFieldsValue({ dataSource });
        //};
        return (
            <Modal
                title={"Búsqueda de OP para Importar"}
                visible={this.props.visible}
                style={{ top: 30 }}
                width="950px"
                onCancel={this.props.onCancel}
                onOk={this.props.onHandleOkImportarOrdenProduccion}

            >
                <Form>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="">
                                <Input.Search
                                    placeholder="Búsqueda por Serie o Documento"
                                    autoComplete="off"
                                    maxLength={100}
                                    onSearch={value => this.props.handleSearch(value)}
                                />
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <Table
                                size="small"
                                style={{ overflowX: 'auto' }}
                                rowKey={record => record.id}
                                dataSource={this.props.formValues.dataSource}
                                rowClassName='cursor-pointer'
                                onRow={
                                    (item) => ({ onClick: () => (this.props.onChangeRow(item)) })
                                }
                                locale={{
                                    emptyText: <Empty
                                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                                        description="No se encontraron datos."
                                    />
                                }}
                                columns={[
                                    {
                                        title: 'Serie',
                                        dataIndex: 'serie',
                                        key: 'serie',
                                        sorter: true
                                    },
                                    {
                                        title: 'Documento',
                                        dataIndex: 'documento',
                                        key: 'documento',
                                        sorter: true
                                    },
                                    {
                                        title: 'Tipo Documento Proveedor',
                                        dataIndex: 'tipoDocumentoProveedor',
                                        key: 'tipoDocumentoProveedor',
                                        sorter: true
                                    },
                                    {
                                        title: 'Número de Documento',
                                        dataIndex: 'numeroDocumento',
                                        key: 'numeroDocumento',
                                        sorter: true
                                    },
                                    {
                                        title: 'Proveedor',
                                        dataIndex: 'razonSocial',
                                        key: 'razonSocial',
                                        sorter: true,
                                        render: (value) => (
                                            <div style={{ minWidth: "150px" }}>{value}</div>
                                        )
                                    },
                                    {
                                        title: 'Fecha',
                                        dataIndex: 'fechaStr',
                                        key: 'fechaStr',
                                        sorter: true
                                    },
                                    {
                                        title: 'Estado',
                                        dataIndex: 'nombreOrdenProduccionEstado',
                                        key: 'nombreOrdenProduccionEstado',
                                        align: 'center',
                                        width: "90px",
                                        fixed: 'right',
                                        render: (value, row) => {
                                            return (<div className="custom-options" >
                                                <Tag color={renderColor(row)}>{value}</Tag>
                                            </div>)
                                        }
                                    }
                                ]}
                            />
                        </div>
                    </div>
                    <br />
                    <div className="row">
                        <div className="col-md-12">
                            <Table
                                size="small"
                                style={{ overflowX: 'auto' }}
                                rowKey={record => record.idProducto}
                                dataSource={this.props.formValues.dataSourceDetalle}
                                locale={{
                                    emptyText: <Empty
                                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                                        description="No se encontraron datos."
                                    />
                                }}
                                columns={[
                                    {
                                        title: 'Código',
                                        dataIndex: 'codigo',
                                        key: 'codigo',
                                        align: 'center',
                                        width: 80,
                                        ellipsis: true
                                    },
                                    {
                                        title: 'Nombre',
                                        dataIndex: 'nombre',
                                        key: 'nombre',
                                        width: 300,
                                        ellipsis: true,
                                    },
                                    {
                                        title: 'Unidad Medida',
                                        dataIndex: 'nombreUnidadMedida',
                                        key: 'nombreUnidadMedida',
                                        width: 120,
                                        ellipsis: true
                                    },
                                    {
                                        title: 'Precio Unitario',
                                        dataIndex: 'precioUnitario',
                                        key: 'precioUnitario',
                                        align: 'center',
                                        width: 90
                                    },
                                    {
                                        title: 'Afecto',
                                        dataIndex: 'flagAfecto',
                                        key: 'flagAfecto',
                                        align: 'center',
                                        width: 62
                                    },
                                    {
                                        title: 'Cantidad',
                                        dataIndex: 'cantidad',
                                        key: 'cantidad',
                                        align: 'center',
                                        width: 90
                                    },
                                    {
                                        title: 'Sub Total',
                                        dataIndex: 'subTotal',
                                        key: 'subTotal',
                                        align: 'center',
                                        width: 90
                                    },
                                    {
                                        title: 'IGV',
                                        dataIndex: 'igv',
                                        key: 'igv',
                                        align: 'center',
                                        width: 80
                                    },
                                    {
                                        title: 'Total',
                                        dataIndex: 'total',
                                        key: 'total',
                                        fixed: 'right',
                                        align: 'center',
                                        width: 90
                                    }

                                ]}
                            />
                        </div>
                    </div>

                </Form>
            </Modal>
        );
    }
}